import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { getAlgoliaDataHitsTotal, getAlgoliaDataQueryId } from 'selectors/algolia2/data'
import { getSelectedFacetNameFirstAttribute } from 'selectors/algolia2/facets'
import { getSearch } from 'selectors/algolia2/url'
import {
  getSeoMetadata,
  getSeoContentForCurrentPage,
  hasReleatedSearches,
  getTitle,
} from '../selectors/seoContent'
import { hasPrintsSelected } from '../selectors/facets'
import { getPagePath } from '../selectors/app'

const mapStateToProps = createStructuredSelector({
  category: (state, ownProps) => getSelectedFacetNameFirstAttribute('category')(state),
  search: getSearch,
  size: (state, ownProps) => getSelectedFacetNameFirstAttribute('size')(state),
  style: (state, ownProps) => getSelectedFacetNameFirstAttribute('styles')(state),
  subject: (state, ownProps) => getSelectedFacetNameFirstAttribute('subject')(state),
  totalHits: getAlgoliaDataHitsTotal,
  metadata: getSeoMetadata,
  hasPrints: hasPrintsSelected,
  seoContent: getSeoContentForCurrentPage,
  hasReleatedSearches,
  queryID: getAlgoliaDataQueryId,
  urlPath: getPagePath,
  title: getTitle,
})

export type ConnectorProps = {
  category: string
  search: string
  size: string
  style: string
  subject: string
  totalHits: number
  metadata: Record<string, any>
  hasPrints: boolean
  seoContent: Record<string, any>
  hasReleatedSearches: boolean
  queryID: string
  urlPath: string
  title: string
}
export default connect(mapStateToProps)
